import { call, put, takeEvery, all } from "redux-saga/effects";

import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_NEW_API_CALL,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER,
  GET_PRODUCT_DETAIL,
  ADD_PRODUCT,
  UPDATE_PRODUCT_CRM,
  DELETE_PRODUCT,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING,
  SEARCH_PRODUCTS_PRICING,
  CREATE_PRODUCTS_PRICING,
  UPDATE_PRODUCTS_PRICING,
  DELETE_PRODUCTS_PRICING,
  SEARCH_PRODUCT_PRICE,
  CREATE_PRODUCT_PRICE,
  UPDATE_PRODUCT_PRICE,
  DELETE_PRODUCT_PRICE,
  GET_PRODUCTS_PRICING_DATA,
  GET_PRODUCTS_RECENT_ACTIVITY,
  GET_PRODUCTS_PRICING_LIST,
  GET_FOOD_ALLERGEN_LIST,
  GET_FOOD_ALLERGEN_DATA,
  CREATE_FOOD_ALLERGEN,
  UPDATE_FOOD_ALLERGEN,
  DELETE_FOOD_ALLERGEN,
  GET_FOOD_DIET_TYPE_LIST,
  GET_FOOD_DIET_TYPE_DATA,
  CREATE_FOOD_DIET_TYPE,
  UPDATE_FOOD_DIET_TYPE,
  DELETE_FOOD_DIET_TYPE,
  GET_PRODUCT_ATTRIBUTE_LIST,
  GET_PRODUCT_ATTRIBUTE_DATA,
  CREATE_PRODUCT_ATTRIBUTE,
  UPDATE_PRODUCT_ATTRIBUTE,
  DELETE_PRODUCT_ATTRIBUTE,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA,
  CREATE_PRODUCT_ATTRIBUTE_VALUE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY,
} from "./actionType";

import {
  getProductSelfServeWidgetRenderSuccess,
  getProductSelfServeWidgetRenderFailure,
  getProductListSuccess,
  getProductListFailure,
  getProductDetailSuccess,
  getProductDetailFailure,
  addProductSuccess,
  addProductFailure,
  updateProductSuccess,
  updateProductFailure,
  deleteProductSuccess,
  deleteProductFailure,
  searchProductsAllowedTimeTrackingSuccess,
  searchProductsAllowedTimeTrackingFailure,
  searchProductsPricingSuccess,
  searchProductsPricingFailure,
  createProductsPricingSuccess,
  createProductsPricingFailure,
  updateProductsPricingSuccess,
  updateProductsPricingFailure,
  deleteProductsPricingSuccess,
  deleteProductsPricingFailure,
  searchProductPriceSuccess,
  searchProductPriceFailure,
  createProductPriceSuccess,
  createProductPriceFailure,
  updateProductPriceSuccess,
  updateProductPriceFailure,
  deleteProductPriceSuccess,
  deleteProductPriceFailure,
  getProductsPricingDataSuccess,
  getProductsPricingDataFailure,
  getProductsRecentActivitySuccess,
  getProductsRecentActivityFailure,
  getProductsPricingListSuccess,
  getProductsPricingListFailure,
  getProductListNewApiCallSuccess,
  getProductListNewApiCallFailure,
  getFoodAllergenListSuccess,
  getFoodAllergenListFailure,
  getFoodAllergenDataSuccess,
  getFoodAllergenDataFailure,
  createFoodAllergenSuccess,
  createFoodAllergenFailure,
  updateFoodAllergenSuccess,
  updateFoodAllergenFailure,
  deleteFoodAllergenSuccess,
  deleteFoodAllergenFailure,
  getFoodDietTypeListSuccess,
  getFoodDietTypeListFailure,
  getFoodDietTypeDataSuccess,
  getFoodDietTypeDataFailure,
  createFoodDietTypeSuccess,
  createFoodDietTypeFailure,
  updateFoodDietTypeSuccess,
  updateFoodDietTypeFailure,
  deleteFoodDietTypeSuccess,
  deleteFoodDietTypeFailure,
  getProductAttributeListSuccess,
  getProductAttributeListFailure,
  getProductAttributeDataSuccess,
  getProductAttributeDataFailure,
  createProductAttributeSuccess,
  createProductAttributeFailure,
  updateProductAttributeSuccess,
  updateProductAttributeFailure,
  deleteProductAttributeSuccess,
  deleteProductAttributeFailure,
  getProductAttributeValueListSuccess,
  getProductAttributeValueListFailure,
  getProductAttributeValueDataSuccess,
  getProductAttributeValueDataFailure,
  createProductAttributeValueSuccess,
  createProductAttributeValueFailure,
  updateProductAttributeValueSuccess,
  updateProductAttributeValueFailure,
  deleteProductAttributeValueSuccess,
  deleteProductAttributeValueFailure,
  getProductAttributeValuePriceListSuccess,
  getProductAttributeValuePriceListFailure,
  getProductAttributeValuePriceDataSuccess,
  getProductAttributeValuePriceDataFailure,
  createProductAttributeValuePriceSuccess,
  createProductAttributeValuePriceFailure,
  updateProductAttributeValuePriceSuccess,
  updateProductAttributeValuePriceFailure,
  deleteProductAttributeValuePriceSuccess,
  deleteProductAttributeValuePriceFailure,
  postProductSelfServePublicBookSuccess,
  postProductSelfServePublicBookFailure,
  postProductSelfServeWidgetCheckAvailabilitySuccess,
  postProductSelfServeWidgetCheckAvailabilityFailure,
} from "./action";

import {
  getProductSelfServeWidgetRenderApiCall,
  getProductListApiCall,
  getProductDetailApiCall,
  addProductApiCall,
  updateProductApiCall,
  deleteProductApiCall,
  searchProductsAllowedTimeTrackingApiCall,
  searchProductsPricingApiCall,
  createProductsPricingApiCall,
  updateProductsPricingApiCall,
  deleteProductsPricingApiCall,
  searchProductPriceApiCall,
  createProductPriceApiCall,
  updateProductPriceApiCall,
  deleteProductPriceApiCall,
  getProductsPricingDataApiCall,
  getProductsRecentActivityApiCall,
  getProductsPricingListApiCall,
  getFoodAllergenListApiCall,
  getFoodAllergenDataApiCall,
  createFoodAllergenApiCall,
  updateFoodAllergenApiCall,
  deleteFoodAllergenApiCall,
  getFoodDietTypeListApiCall,
  getFoodDietTypeDataApiCall,
  createFoodDietTypeApiCall,
  updateFoodDietTypeApiCall,
  deleteFoodDietTypeApiCall,
  getProductAttributeListApiCall,
  getProductAttributeDataApiCall,
  createProductAttributeApiCall,
  updateProductAttributeApiCall,
  deleteProductAttributeApiCall,
  getProductAttributeValueListApiCall,
  getProductAttributeValueDataApiCall,
  createProductAttributeValueApiCall,
  updateProductAttributeValueApiCall,
  deleteProductAttributeValueApiCall,
  getProductAttributeValuePriceListApiCall,
  getProductAttributeValuePriceDataApiCall,
  createProductAttributeValuePriceApiCall,
  updateProductAttributeValuePriceApiCall,
  deleteProductAttributeValuePriceApiCall,
  postProductSelfServePublicBookApiCall,
  postProductSelfServeWidgetCheckAvailabilityApiCall,
} from "../../helpers/fakebackend_helper";

// Post Product Self Serve Public Book
function* postProductSelfServePublicBookWorker(action) {
  try {
    const response = yield call(postProductSelfServePublicBookApiCall, action.payload);
    yield put(postProductSelfServePublicBookSuccess(response));
  } catch (error) {
    yield put(postProductSelfServePublicBookFailure());
  }
}
function* postProductSelfServePublicBookWatcher() {
  yield takeEvery(POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK, postProductSelfServePublicBookWorker);
}

// Post Product Self Serve Widget Check Availability
function* postProductSelfServeWidgetCheckAvailabilityWorker(action) {
  try {
    const response = yield call(postProductSelfServeWidgetCheckAvailabilityApiCall, action.payload);
    yield put(postProductSelfServeWidgetCheckAvailabilitySuccess(response));
  } catch (error) {
    yield put(postProductSelfServeWidgetCheckAvailabilityFailure());
  }
}
function* postProductSelfServeWidgetCheckAvailabilityWatcher() {
  yield takeEvery(POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY, postProductSelfServeWidgetCheckAvailabilityWorker);
}

// Get Product Self Serve Widget Render
function* getProductSelfServeWidgetRenderWorker(action) {
  try {
    const response = yield call(getProductSelfServeWidgetRenderApiCall, action.payload);
    yield put(getProductSelfServeWidgetRenderSuccess(response));
  } catch (error) {
    yield put(getProductSelfServeWidgetRenderFailure());
  }
}

function* getProductSelfServeWidgetRenderWatcher() {
  yield takeEvery(GET_PRODUCT_SELF_SERVE_WIDGET_RENDER, getProductSelfServeWidgetRenderWorker);
}

// Get Product List Worker

function* getProductListWorker() {
  try {
    const response = yield call(getProductListApiCall);
    yield put(getProductListSuccess(response));
  } catch (error) {
    yield put(getProductListFailure());
  }
}

// Get Product List Watcher

function* getProductListWatcher() {
  yield takeEvery(GET_PRODUCT_LIST, getProductListWorker);
}
//
// Get Product List New Api Call Worker
function* getProductListNewApiCallWorker() {
  try {
    const response = yield call(getProductListApiCall);
    yield put(getProductListNewApiCallSuccess(response));
  } catch (error) {
    yield put(getProductListNewApiCallFailure());
  }
}

// Get Product List New Api Call Watcher

function* getProductListNewApiCallWatcher() {
  yield takeEvery(
    GET_PRODUCT_LIST_NEW_API_CALL,
    getProductListNewApiCallWorker
  );
}

// Get Product Detail
function* getProductDetailWorker(action) {
  try {
    const response = yield call(getProductDetailApiCall, action.payload);
    yield put(getProductDetailSuccess(response));
  } catch (error) {
    yield put(getProductDetailFailure());
  }
}

function* getProductDetailWatcher() {
  yield takeEvery(GET_PRODUCT_DETAIL, getProductDetailWorker);
}

// Add Product
function* addProductWorker(action) {
  try {
    const response = yield call(addProductApiCall, action.payload);
    yield put(addProductSuccess(response));
  } catch (error) {
    yield put(addProductFailure());
  }
}

function* addProductWatcher() {
  yield takeEvery(ADD_PRODUCT, addProductWorker);
}

// Update Product
function* updateProductWorker(action) {
  try {
    const response = yield call(updateProductApiCall, action.payload);
    yield put(updateProductSuccess(response));
  } catch (error) {
    yield put(updateProductFailure());
  }
}

function* updateProductWatcher() {
  yield takeEvery(UPDATE_PRODUCT_CRM, updateProductWorker);
}

// Delete Product
function* deleteProductWorker(action) {
  try {
    const response = yield call(deleteProductApiCall, action.payload);
    yield put(deleteProductSuccess(response));
  } catch (error) {
    yield put(deleteProductFailure());
  }
}

function* deleteProductWatcher() {
  yield takeEvery(DELETE_PRODUCT, deleteProductWorker);
}

// Search products allowed time tracking
function* searchProductsAllowedTimeTrackingWorker(action) {
  try {
    const response = yield call(
      searchProductsAllowedTimeTrackingApiCall,
      action.payload
    );
    yield put(searchProductsAllowedTimeTrackingSuccess(response));
  } catch (error) {
    yield put(searchProductsAllowedTimeTrackingFailure());
  }
}

function* searchProductsAllowedTimeTrackingWatcher() {
  yield takeEvery(
    SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING,
    searchProductsAllowedTimeTrackingWorker
  );
}

// Search products pricing
function* searchProductsPricingWorker(action) {
  try {
    const response = yield call(searchProductsPricingApiCall, action.payload);
    yield put(searchProductsPricingSuccess(response));
  } catch (error) {
    yield put(searchProductsPricingFailure());
  }
}

function* searchProductsPricingWatcher() {
  yield takeEvery(SEARCH_PRODUCTS_PRICING, searchProductsPricingWorker);
}

// Create products pricing
function* createProductsPricingWorker(action) {
  try {
    const response = yield call(createProductsPricingApiCall, action.payload);
    yield put(createProductsPricingSuccess(response));
  } catch (error) {
    yield put(createProductsPricingFailure());
  }
}

function* createProductsPricingWatcher() {
  yield takeEvery(CREATE_PRODUCTS_PRICING, createProductsPricingWorker);
}

// Update products pricing
function* updateProductsPricingWorker(action) {
  try {
    const response = yield call(updateProductsPricingApiCall, action.payload);
    console.log("response", response);
    yield put(updateProductsPricingSuccess(response));
  } catch (error) {
    yield put(updateProductsPricingFailure());
  }
}

function* updateProductsPricingWatcher() {
  yield takeEvery(UPDATE_PRODUCTS_PRICING, updateProductsPricingWorker);
}

// Delete products pricing
function* deleteProductsPricingWorker(action) {
  try {
    const response = yield call(deleteProductsPricingApiCall, action.payload);
    yield put(deleteProductsPricingSuccess(response));
  } catch (error) {
    yield put(deleteProductsPricingFailure());
  }
}

function* deleteProductsPricingWatcher() {
  yield takeEvery(DELETE_PRODUCTS_PRICING, deleteProductsPricingWorker);
}

// Task 24858 - ProductPrice writes (the dated price schedule). Reads come back
// inside product/data as productprice_data, so only the writes live here.
function* searchProductPriceWorker(action) {
  try {
    const response = yield call(searchProductPriceApiCall, action.payload);
    yield put(searchProductPriceSuccess(response));
  } catch (error) {
    yield put(searchProductPriceFailure());
  }
}

function* searchProductPriceWatcher() {
  yield takeEvery(SEARCH_PRODUCT_PRICE, searchProductPriceWorker);
}

function* createProductPriceWorker(action) {
  try {
    const response = yield call(createProductPriceApiCall, action.payload);
    yield put(createProductPriceSuccess(response));
  } catch (error) {
    yield put(createProductPriceFailure());
  }
}

function* createProductPriceWatcher() {
  yield takeEvery(CREATE_PRODUCT_PRICE, createProductPriceWorker);
}

function* updateProductPriceWorker(action) {
  try {
    const response = yield call(updateProductPriceApiCall, action.payload);
    yield put(updateProductPriceSuccess(response));
  } catch (error) {
    yield put(updateProductPriceFailure());
  }
}

function* updateProductPriceWatcher() {
  yield takeEvery(UPDATE_PRODUCT_PRICE, updateProductPriceWorker);
}

function* deleteProductPriceWorker(action) {
  try {
    const response = yield call(deleteProductPriceApiCall, action.payload);
    yield put(deleteProductPriceSuccess(response));
  } catch (error) {
    yield put(deleteProductPriceFailure());
  }
}

function* deleteProductPriceWatcher() {
  yield takeEvery(DELETE_PRODUCT_PRICE, deleteProductPriceWorker);
}

// Get products pricing data
function* getProductsPricingDataWorker(action) {
  try {
    const response = yield call(getProductsPricingDataApiCall, action.payload);
    yield put(getProductsPricingDataSuccess(response));
  } catch (error) {
    yield put(getProductsPricingDataFailure());
  }
}

function* getProductsPricingDataWatcher() {
  yield takeEvery(GET_PRODUCTS_PRICING_DATA, getProductsPricingDataWorker);
}

// Get products recent activity
function* getProductsRecentActivityWorker(action) {
  try {
    const response = yield call(
      getProductsRecentActivityApiCall,
      action.payload
    );
    yield put(getProductsRecentActivitySuccess(response));
  } catch (error) {
    yield put(getProductsRecentActivityFailure());
  }
}

function* getProductsRecentActivityWatcher() {
  yield takeEvery(
    GET_PRODUCTS_RECENT_ACTIVITY,
    getProductsRecentActivityWorker
  );
}

// Get products pricing list
function* getProductsPricingListWorker(action) {
  try {
    const response = yield call(getProductsPricingListApiCall, action.payload);
    yield put(getProductsPricingListSuccess(response));
  } catch (error) {
    yield put(getProductsPricingListFailure());
  }
}

function* getProductsPricingListWatcher() {
  yield takeEvery(GET_PRODUCTS_PRICING_LIST, getProductsPricingListWorker);
}

// Food Allergen List
function* getFoodAllergenListWorker(action) {
  try {
    // Task 24831 - undefined for every logged-in caller, which is the same
    // call it has always made.
    const response = yield call(getFoodAllergenListApiCall, action?.payload);
    yield put(getFoodAllergenListSuccess(response));
  } catch (error) {
    yield put(getFoodAllergenListFailure());
  }
}

function* getFoodAllergenListWatcher() {
  yield takeEvery(GET_FOOD_ALLERGEN_LIST, getFoodAllergenListWorker);
}

// Food Allergen Data
function* getFoodAllergenDataWorker(action) {
  try {
    const response = yield call(getFoodAllergenDataApiCall, action.payload);
    yield put(getFoodAllergenDataSuccess(response));
  } catch (error) {
    yield put(getFoodAllergenDataFailure());
  }
}

function* getFoodAllergenDataWatcher() {
  yield takeEvery(GET_FOOD_ALLERGEN_DATA, getFoodAllergenDataWorker);
}

// Create Food Allergen
function* createFoodAllergenWorker(action) {
  try {
    const response = yield call(createFoodAllergenApiCall, action.payload);
    yield put(createFoodAllergenSuccess(response));
  } catch (error) {
    yield put(createFoodAllergenFailure());
  }
}

function* createFoodAllergenWatcher() {
  yield takeEvery(CREATE_FOOD_ALLERGEN, createFoodAllergenWorker);
}

// Update Food Allergen
function* updateFoodAllergenWorker(action) {
  try {
    const response = yield call(updateFoodAllergenApiCall, action.payload);
    yield put(updateFoodAllergenSuccess(response));
  } catch (error) {
    yield put(updateFoodAllergenFailure());
  }
}

function* updateFoodAllergenWatcher() {
  yield takeEvery(UPDATE_FOOD_ALLERGEN, updateFoodAllergenWorker);
}

// Delete Food Allergen
function* deleteFoodAllergenWorker(action) {
  try {
    const response = yield call(deleteFoodAllergenApiCall, action.payload);
    yield put(deleteFoodAllergenSuccess(response));
  } catch (error) {
    yield put(deleteFoodAllergenFailure());
  }
}

function* deleteFoodAllergenWatcher() {
  yield takeEvery(DELETE_FOOD_ALLERGEN, deleteFoodAllergenWorker);
}

// Food Diet Type List
function* getFoodDietTypeListWorker(action) {
  try {
    // Task 24831 - as the allergen worker above.
    const response = yield call(getFoodDietTypeListApiCall, action?.payload);
    yield put(getFoodDietTypeListSuccess(response));
  } catch (error) {
    yield put(getFoodDietTypeListFailure());
  }
}

function* getFoodDietTypeListWatcher() {
  yield takeEvery(GET_FOOD_DIET_TYPE_LIST, getFoodDietTypeListWorker);
}

// Food Diet Type Data
function* getFoodDietTypeDataWorker(action) {
  try {
    const response = yield call(getFoodDietTypeDataApiCall, action.payload);
    yield put(getFoodDietTypeDataSuccess(response));
  } catch (error) {
    yield put(getFoodDietTypeDataFailure());
  }
}

function* getFoodDietTypeDataWatcher() {
  yield takeEvery(GET_FOOD_DIET_TYPE_DATA, getFoodDietTypeDataWorker);
}

// Create Food Diet Type
function* createFoodDietTypeWorker(action) {
  try {
    const response = yield call(createFoodDietTypeApiCall, action.payload);
    yield put(createFoodDietTypeSuccess(response));
  } catch (error) {
    yield put(createFoodDietTypeFailure());
  }
}

function* createFoodDietTypeWatcher() {
  yield takeEvery(CREATE_FOOD_DIET_TYPE, createFoodDietTypeWorker);
}

// Update Food Diet Type
function* updateFoodDietTypeWorker(action) {
  try {
    const response = yield call(updateFoodDietTypeApiCall, action.payload);
    yield put(updateFoodDietTypeSuccess(response));
  } catch (error) {
    yield put(updateFoodDietTypeFailure());
  }
}

function* updateFoodDietTypeWatcher() {
  yield takeEvery(UPDATE_FOOD_DIET_TYPE, updateFoodDietTypeWorker);
}

// Delete Food Diet Type
function* deleteFoodDietTypeWorker(action) {
  try {
    const response = yield call(deleteFoodDietTypeApiCall, action.payload);
    yield put(deleteFoodDietTypeSuccess(response));
  } catch (error) {
    yield put(deleteFoodDietTypeFailure());
  }
}

function* deleteFoodDietTypeWatcher() {
  yield takeEvery(DELETE_FOOD_DIET_TYPE, deleteFoodDietTypeWorker);
}

// Product Attribute List
function* getProductAttributeListWorker() {
  try {
    const response = yield call(getProductAttributeListApiCall);
    yield put(getProductAttributeListSuccess(response));
  } catch (error) {
    yield put(getProductAttributeListFailure());
  }
}

function* getProductAttributeListWatcher() {
  yield takeEvery(GET_PRODUCT_ATTRIBUTE_LIST, getProductAttributeListWorker);
}

// Product Attribute Data
function* getProductAttributeDataWorker(action) {
  try {
    const response = yield call(getProductAttributeDataApiCall, action.payload);
    yield put(getProductAttributeDataSuccess(response));
  } catch (error) {
    yield put(getProductAttributeDataFailure());
  }
}

function* getProductAttributeDataWatcher() {
  yield takeEvery(GET_PRODUCT_ATTRIBUTE_DATA, getProductAttributeDataWorker);
}

// Create Product Attribute
function* createProductAttributeWorker(action) {
  try {
    const response = yield call(createProductAttributeApiCall, action.payload);
    yield put(createProductAttributeSuccess(response));
  } catch (error) {
    yield put(createProductAttributeFailure());
  }
}

function* createProductAttributeWatcher() {
  yield takeEvery(CREATE_PRODUCT_ATTRIBUTE, createProductAttributeWorker);
}

// Update Product Attribute
function* updateProductAttributeWorker(action) {
  try {
    const response = yield call(updateProductAttributeApiCall, action.payload);
    yield put(updateProductAttributeSuccess(response));
  } catch (error) {
    yield put(updateProductAttributeFailure());
  }
}

function* updateProductAttributeWatcher() {
  yield takeEvery(UPDATE_PRODUCT_ATTRIBUTE, updateProductAttributeWorker);
}

// Delete Product Attribute
function* deleteProductAttributeWorker(action) {
  try {
    const response = yield call(deleteProductAttributeApiCall, action.payload);
    yield put(deleteProductAttributeSuccess(response));
  } catch (error) {
    yield put(deleteProductAttributeFailure());
  }
}

function* deleteProductAttributeWatcher() {
  yield takeEvery(DELETE_PRODUCT_ATTRIBUTE, deleteProductAttributeWorker);
}

// Product Attribute Value List
function* getProductAttributeValueListWorker() {
  try {
    const response = yield call(getProductAttributeValueListApiCall);
    yield put(getProductAttributeValueListSuccess(response));
  } catch (error) {
    yield put(getProductAttributeValueListFailure());
  }
}

function* getProductAttributeValueListWatcher() {
  yield takeEvery(GET_PRODUCT_ATTRIBUTE_VALUE_LIST, getProductAttributeValueListWorker);
}

// Product Attribute Value Data
function* getProductAttributeValueDataWorker(action) {
  try {
    const response = yield call(getProductAttributeValueDataApiCall, action.payload);
    yield put(getProductAttributeValueDataSuccess(response));
  } catch (error) {
    yield put(getProductAttributeValueDataFailure());
  }
}

function* getProductAttributeValueDataWatcher() {
  yield takeEvery(GET_PRODUCT_ATTRIBUTE_VALUE_DATA, getProductAttributeValueDataWorker);
}

// Create Product Attribute Value
function* createProductAttributeValueWorker(action) {
  try {
    const response = yield call(createProductAttributeValueApiCall, action.payload);
    yield put(createProductAttributeValueSuccess(response));
  } catch (error) {
    yield put(createProductAttributeValueFailure());
  }
}

function* createProductAttributeValueWatcher() {
  yield takeEvery(CREATE_PRODUCT_ATTRIBUTE_VALUE, createProductAttributeValueWorker);
}

// Update Product Attribute Value
function* updateProductAttributeValueWorker(action) {
  try {
    const response = yield call(updateProductAttributeValueApiCall, action.payload);
    yield put(updateProductAttributeValueSuccess(response));
  } catch (error) {
    yield put(updateProductAttributeValueFailure());
  }
}

function* updateProductAttributeValueWatcher() {
  yield takeEvery(UPDATE_PRODUCT_ATTRIBUTE_VALUE, updateProductAttributeValueWorker);
}

// Delete Product Attribute Value
function* deleteProductAttributeValueWorker(action) {
  try {
    const response = yield call(deleteProductAttributeValueApiCall, action.payload);
    yield put(deleteProductAttributeValueSuccess(response));
  } catch (error) {
    yield put(deleteProductAttributeValueFailure());
  }
}

function* deleteProductAttributeValueWatcher() {
  yield takeEvery(DELETE_PRODUCT_ATTRIBUTE_VALUE, deleteProductAttributeValueWorker);
}

// Product Attribute Value Price List
function* getProductAttributeValuePriceListWorker() {
  try {
    const response = yield call(getProductAttributeValuePriceListApiCall);
    yield put(getProductAttributeValuePriceListSuccess(response));
  } catch (error) {
    yield put(getProductAttributeValuePriceListFailure());
  }
}

function* getProductAttributeValuePriceListWatcher() {
  yield takeEvery(GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST, getProductAttributeValuePriceListWorker);
}

// Product Attribute Value Price Data
function* getProductAttributeValuePriceDataWorker(action) {
  try {
    const response = yield call(getProductAttributeValuePriceDataApiCall, action.payload);
    yield put(getProductAttributeValuePriceDataSuccess(response));
  } catch (error) {
    yield put(getProductAttributeValuePriceDataFailure());
  }
}

function* getProductAttributeValuePriceDataWatcher() {
  yield takeEvery(GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA, getProductAttributeValuePriceDataWorker);
}

// Create Product Attribute Value Price
function* createProductAttributeValuePriceWorker(action) {
  try {
    const response = yield call(createProductAttributeValuePriceApiCall, action.payload);
    yield put(createProductAttributeValuePriceSuccess(response));
  } catch (error) {
    yield put(createProductAttributeValuePriceFailure());
  }
}

function* createProductAttributeValuePriceWatcher() {
  yield takeEvery(CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE, createProductAttributeValuePriceWorker);
}

// Update Product Attribute Value Price
function* updateProductAttributeValuePriceWorker(action) {
  try {
    const response = yield call(updateProductAttributeValuePriceApiCall, action.payload);
    yield put(updateProductAttributeValuePriceSuccess(response));
  } catch (error) {
    yield put(updateProductAttributeValuePriceFailure());
  }
}

function* updateProductAttributeValuePriceWatcher() {
  yield takeEvery(UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE, updateProductAttributeValuePriceWorker);
}

// Delete Product Attribute Value Price
function* deleteProductAttributeValuePriceWorker(action) {
  try {
    const response = yield call(deleteProductAttributeValuePriceApiCall, action.payload);
    yield put(deleteProductAttributeValuePriceSuccess(response));
  } catch (error) {
    yield put(deleteProductAttributeValuePriceFailure());
  }
}

function* deleteProductAttributeValuePriceWatcher() {
  yield takeEvery(DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE, deleteProductAttributeValuePriceWorker);
}

// Saga Main Function export all saga
function* Products() {
  yield all([
    postProductSelfServePublicBookWatcher(),
    postProductSelfServeWidgetCheckAvailabilityWatcher(),
    getProductSelfServeWidgetRenderWatcher(),
    getProductListWatcher(),
    getProductListNewApiCallWatcher(),
    getProductDetailWatcher(),
    addProductWatcher(),
    updateProductWatcher(),
    deleteProductWatcher(),
    searchProductsAllowedTimeTrackingWatcher(),
    searchProductsPricingWatcher(),
    createProductsPricingWatcher(),
    updateProductsPricingWatcher(),
    deleteProductsPricingWatcher(),
    getProductsPricingDataWatcher(),
    getProductsRecentActivityWatcher(),
    getProductsPricingListWatcher(),
    getFoodAllergenListWatcher(),
    getFoodAllergenDataWatcher(),
    createFoodAllergenWatcher(),
    updateFoodAllergenWatcher(),
    deleteFoodAllergenWatcher(),
    getFoodDietTypeListWatcher(),
    getFoodDietTypeDataWatcher(),
    createFoodDietTypeWatcher(),
    updateFoodDietTypeWatcher(),
    deleteFoodDietTypeWatcher(),
    getProductAttributeListWatcher(),
    getProductAttributeDataWatcher(),
    createProductAttributeWatcher(),
    updateProductAttributeWatcher(),
    deleteProductAttributeWatcher(),
    getProductAttributeValueListWatcher(),
    getProductAttributeValueDataWatcher(),
    createProductAttributeValueWatcher(),
    updateProductAttributeValueWatcher(),
    deleteProductAttributeValueWatcher(),
    getProductAttributeValuePriceListWatcher(),
    getProductAttributeValuePriceDataWatcher(),
    createProductAttributeValuePriceWatcher(),
    updateProductAttributeValuePriceWatcher(),
    deleteProductAttributeValuePriceWatcher(),
    searchProductPriceWatcher(),
    createProductPriceWatcher(),
    updateProductPriceWatcher(),
    deleteProductPriceWatcher(),
  ]);
}

export default Products;
